/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Dyna ERP API
 * OpenAPI spec version: 1.0.0
 */

export type ListJobsCrew = typeof ListJobsCrew[keyof typeof ListJobsCrew] | null;


export const ListJobsCrew = {
  staff: 'staff',
  visitor: 'visitor',
} as const;
